export const API_ERRORS = {
    401: 'Invalid Auth Token.',
    403: 'Invalid Auth Token.',
};
